import { LorebookVisibility } from "@next-platform/packages-ts-types";
function getLorebookEntriesCount(lorebook) {
    if (typeof lorebook.num_entries === "number")
        return lorebook.num_entries;
    if (Array.isArray(lorebook.entries))
        return lorebook.entries.length;
    return 0;
}
function isPrivateLorebookVisibility(visibility) {
    return visibility === LorebookVisibility.PRIVATE || visibility === LorebookVisibility.PERMANENTLY_PRIVATE;
}
function getLorebookCardDisplayData(lorebook) {
    const visibility = lorebook.visibility ?? null;
    return {
        id: lorebook.id ?? null,
        name: lorebook.name ?? "",
        description: lorebook.description ?? "",
        creatorUsername: lorebook.creator_username ?? "",
        avatarUrl: lorebook.avatar_url ?? null,
        numEntries: getLorebookEntriesCount(lorebook),
        visibility,
        isPrivate: isPrivateLorebookVisibility(visibility),
    };
}
export { getLorebookCardDisplayData, isPrivateLorebookVisibility };
